import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	FreudSelectModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentExpirationSelectComponent } from './appointment-expiration-select.component';

@NgModule({
	declarations: [AppointmentExpirationSelectComponent],
	imports: [
		CommonModule,
		FreudSelectModule,
		TranslateModule.forChild(),
		FreudTooltipModule,
		ReactiveFormsModule,
	],
	exports: [AppointmentExpirationSelectComponent],
	providers: [],
})
export class AppointmentExpirationSelectModule {}
